module.exports = __webpack_public_path__ + "img/leftArrow.01e3e36f.svg";